<template>
  <div>
    <div v-if="profile_data.private != 1 && post_count > 0">
      <ul class="gallery-wrap" v-show="tabs == 'summary' || tabs == 'post'">
        <li class="gallery_item detail-trigger" v-for="(post_data, index) in post_data" :key="post_data.media_id" @click="detail(index)" :class="printmode ? 'print' : ''">
          <div class="gallery_img error" v-if="post_data.img_error">
            <font-awesome-icon icon="exclamation-circle" />
          </div>
          <img
            class="gallery_img"
            :src="post_data.img_url_m + '?'+actionId"
            @load="imgLoaded()"
            @error="imgError(index)"
            v-else
          />
          <div class="media_type" v-show="post_data.media_type === 'GraphSidecar'" :class="printmode ? 'printmode' : ''">
            <font-awesome-icon  :icon="['far', 'clone']" class="media_tag list"/>
          </div>
          <div class="media_type" v-show="post_data.media_type === 'GraphVideo' && (post_data.s3_url == 'feed' || post_data.s3_url == null)" :class="printmode ? 'printmode' : ''">
            <font-awesome-icon  :icon="['far', 'play']"  class="media_tag list"/>
          </div>
          <div class="media_type" v-show="post_data.media_type === 'GraphVideo' && post_data.s3_url == 'clips'" :class="printmode ? 'printmode' : ''">
            <img src="../../../assets/reels.png" class="media_type-reels" alt />
          </div>
          <div class="mask">
            <div class="caption">
              <font-awesome-icon :icon="['fal', 'heart']" style="margin-left:6px; font-size:12px" />{{ post_data.like_count > 0 ? post_data.like_count : '非表示' }}
              <font-awesome-icon :icon="['fal', 'comment']" style="margin-left:6px; font-size:12px" />{{ post_data.comments_count }}
              <font-awesome-icon :icon="['fal', 'percentage']" style="margin-left:6px; font-size:12px" />{{ post_data.egr > 0 ? post_data.egr + '%' : '0%' }}
              <span v-show="post_data.media_type === 'GraphVideo'">
                <font-awesome-icon :icon="['fas', 'play']" style="margin-left:6px; font-size:12px" />{{ post_data.video_view_count }}
              </span><br /><br />{{ post_data.timestamp }}
            </div>
          </div>
          <div class="pr_type" v-show="post_data.pr_flag" :class="printmode ? 'printmode' : ''">
            <div class="pr_tag">PR</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="no-media-message" v-else-if="profile_data.private != 1 && post_count == 0">
      <img src="../../../assets/post_image.png" style="opacity:0.5" alt />
      <div>{{ no_media_message }}</div>
    </div>
    <div class="gallery-wrap-private" v-else>このアカウントは非公開か削除されています</div>
  </div>
</template>

<script>
export default {
  props: ["profile_data", "post_data", "post_count", "no_media_message", "tabs"],
  name: "postList",
  data() {
    return {
      detail_loading: true,
      tagged_user: false,
      actionId: Math.floor(new Date().getTime() / 1000)
    };
  },
  computed:{
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    printmode(){
      // if (this.admin_mode) {
      //   return true
      // } else{
      //   return false
      // }
      return false
    },
  },
  methods: {
    detail(index) {
      this.$emit("detail", index, 'feed');
    },
    imgError(index) {
      this.$emit("imgError", index);
    },
    imgLoaded() {
      this.$emit("imgLoaded");
    },
  },
  filters: {},
  watch: {
    post_data(){
      this.actionId += 1
    }
  }
};
</script>

<style></style>
